export default __webpack_public_path__ + "static/media/icon-solid-up.8adc20f4.svg";